const BASEURL = process.env.REACT_APP_API_URL

export const API = {
    //common
    baseUrl: BASEURL,
    checkEmailExist: BASEURL + 'checkEmailExist',
    getAllCommunities: BASEURL + 'getAllCommunities',
    getAllCommunityMemberTypes: BASEURL + 'getAllCommunityMemberTypes',
    countriesList: BASEURL + 'countriesList',
    uploadFilePath: `${process.env.REACT_APP_IMAGE_URL}`,
    uploadCv: BASEURL + 'uploadPhysicianDocument',
    signup: BASEURL + 'signup',
    emailVerify: BASEURL + 'emailVerify',
    checkCommunityExist: BASEURL + 'checkCommunityExist',
    login: BASEURL + 'login',
    socialMediaLogin: BASEURL + 'SocialMediaLogin',
    forgotUserPassword: BASEURL + 'forgotUserPassword',
    checkResetPasswordToken: BASEURL + 'checkResetPasswordToken',
    resetUserPassword: BASEURL + 'resetUserPassword',
    getProfileQuestion: BASEURL +'getProfileQuestion',
    joinCommunity: BASEURL + 'joinCommunity',
    getSiteSettings: BASEURL + 'getSiteSettings',
    

}